import React, { useState } from "react";
import ChatGPTHistory from "../molecules/ChatGPTHistory";
import ChatGPTForm from "../molecules/ChatGPTForm";
import { CHAT_GPT_SYSTEM_MESSAGE } from "../../utils/chatGPTSystemMesage";
import useSetPreset from "../../hooks/useSetPreset";

const ChatGPTWidget = () => {
  const initialMessage = { role: "system", content: CHAT_GPT_SYSTEM_MESSAGE };
  const [messages, setMessages] = useState([initialMessage]);
  const { setPreset } = useSetPreset();

  return (
    <div>
      <ChatGPTHistory
        messages={messages}
        setMessages={setMessages}
        updatePreset={setPreset}
      />
      <ChatGPTForm
        messages={messages}
        setMessages={setMessages}
        updatePreset={setPreset}
      />
    </div>
  );
};

export default ChatGPTWidget;
